<template>
  <div>
    <div class="account-list" v-if="!loading">
      <div class="search-content" v-if="userInfo">
        <div class="user-info">
          <!-- 解决企业微信出现的缓存，显示的头像会是上一次的头像 -->
          <img
            :src="`${userInfo.avatar}`"
            class="head-pic"
            v-if="userInfo.avatar"
          />
          <img
            src="../../../../../assets/imgs/work-wx/customer/bind-customer-account/default-head.png"
            class="head-pic"
            v-else
          />
          <div class="info">
            <div class="user-name">
              {{ userInfo.user_account_id || ' ' }}
            </div>
            <div class="user-phone">
              {{ userInfo.mobile_phone }}
            </div>
          </div>
          <div class="bind-btn" @click="onBindAccount()">绑定</div>
        </div>
      </div>

      <div class="no-data" v-else>
        <img
          src="../../../../../assets/imgs/work-wx/customer/bind-customer-account/no-data.png"
        />
        <span>没有找到对应的用户信息</span>
      </div>
    </div>

    <div class="loading" v-else>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>

<script>
import toast from '@/services/toast.js';
import bindCustomerAccountService from '../../services/bind-customer-account-service.js';

export default {
  props: {
    userInfo: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      isJump: this.$route.query.isJump || false,
    };
  },
  methods: {
    async onBindAccount() {
      try {
        this.loading = true;
        const userId = localStorage.getItem('user_id');
        console.log('参数为', this.userInfo, userId);
        await bindCustomerAccountService.bindAccount({
          user_account_id: this.userInfo.user_account_id,
          wwx_user_id: userId,
        });
        toast.show('绑定成功');
        // 是否为跳转的，如果是则跳转到
        if (this.isJump) {
          this.$router.replace({ name: 'WorkWXCustomer' });
          return;
        }
        this.$router.back();
      } catch (e) {
        toast.show('绑定失败');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.account-list {
  padding: 0 12px;
  .search-content {
    .user-info {
      padding: 12px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #dedede;
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 20px;
      .head-pic {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
      }
      .info {
        margin-left: 8px;
        flex: 1;
        .user-name {
          color: #222222;
          font-weight: 600;
        }
        .user-phone {
          color: rgba(34, 34, 34, 0.65);
        }
      }
      .bind-btn {
        width: 80px;
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        border: 1px solid #00a2fc;
        margin-left: 16px;
        color: #00a2fc;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
  .no-data {
    padding: 100px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    > img {
      width: 75px;
      height: 75px;
      margin-bottom: 12px;
    }
    > span {
      color: #222222;
    }
  }
}

.loading {
  width: 100%;
  padding-top: 100px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #918f8f;
}
</style>
